<template>
  <b-card>
    <b-row>
        <b-col class="col-md-12">
          <b-skeleton-table
              :rows="5"
              :columns="5"
              :table-props="{ bordered: true, striped: true }"
              v-if="loading"
          ></b-skeleton-table>
            <vue-good-table
                v-else
                :columns="columns"
                :rows="rows"
                :current-page="currentPage"
                :pagination-options="{
                    enabled: true,
                    perPage:pageLength
                }"
            >
                <template
                    slot="table-row"
                    slot-scope="props"
                >
                    <span v-if="props.column.field === 'status'">
                        <b-badge :variant="statusVariant(props.row.status)">
                            {{ props.row.status ? 'Pago' : 'Em Aberto' }}
                        </b-badge>
                        <span class="ml-1" v-if="!props.row.status">
                          <b-badge variant='info'>
                            <a :href="mountURLBankSlip(props.row.uuid_code)" target="_blank">
                              {{ 'Obter a 2ª via' }}
                            </a>
                          </b-badge>
                        </span>
                    </span>
                </template>

                <template
                    slot="pagination-bottom"
                    slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Total de {{ total }} registros </span>
                        </div>
                        <div>
                            <b-pagination
                                :value="1"
                                :total-rows="total"
                                :per-page="pageLength"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @input="getBankSlips"
                                v-model="currentPage"
                            >
                                <template #prev-text>
                                    <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                    />
                                </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>

            </vue-good-table>
        </b-col>
    </b-row>
  </b-card>
</template>

<script>
import BankSlipService from "@/services/BankSlipService";
import getEndPoint from "@/config/getEndPoint";

import { VueGoodTable } from 'vue-good-table'

import moment from 'moment'
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
    name: "BankSlips",
    components:{
        VueGoodTable
    },
    mounted() {
        this.getBankSlips()
    },
    data(){
        return {
            pageLength: null,
            currentPage: null,
            total: null,
            columns: [
                {
                    label: 'Data vencimento',
                    field: 'data_vencimento',
                    sortable: false
                },
                {
                    label: 'Data Pagamento',
                    field: 'data_pagamento',
                    sortable: false
                },
                {
                    label: 'Valor',
                    field: 'valor_boleto',
                    sortable: false
                },
                {
                    label: 'Linha digitavel',
                    field: 'num_boleto',
                    sortable: false
                },
                {
                    label: 'Status',
                    field: 'status',
                    sortable: false
                },
            ],
            rows: [],
          loading: false,
        }
    },
    methods:{
        mountURLBankSlip(id) {
          return `${getEndPoint.get()}/bank-slips/document/${id}`;
        },
        statusVariant(status) {
            return status ? 'success' : 'danger';
        },
        getBankSlips(page = 1){
            this.currentPage = page;
            this.loading = true;

            BankSlipService.getBankSlips(page).then(resp => {
                this.rows = resp.data.data.map(item => {
                    return {
                        ...item,
                        data_vencimento: moment(item.data_vencimento).format('DD/MM/YYYY'),
                        data_pagamento: item.data_pagamento !== null ? moment(item.data_pagamento).format('DD/MM/YYYY') : null,
                        valor_boleto: parseFloat(item.valor_boleto)
                            .toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }),
                        status: item.data_pagamento !== null
                    }
                })

                this.perPage = resp.data.per_page;
                this.total = resp.data.total;
                this.loading = false;
            }).catch(err => {
              this.loading = false;
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Oops!',
                      icon: 'BellIcon',
                      text: 'Ocorreu um erro ao buscar os dados.',
                      variant: 'danger',
                    },
                  },
                  {
                    position: 'top-center'
                  })
            })
        }
    }
}
</script>

<style>

</style>
